module.exports = __webpack_public_path__ + "img/SES_8752.fb59f9ca.jpg";